import { takeLatest, call, put } from 'redux-saga/effects';

import { checkIfAPIResponseIsSuccess } from 'utils/functions/general';
import { setSelectedCompanyProfile } from 'modules/common/actions';

import { addCompany } from './api';
import {
  fetchAddOrEditCompanySubmissionSuccess,
  fetchAddOrEditCompanySubmissionFail,
} from './actions';
import companiesActionTypes from './action-types';

function* fetchAddOrEditCompanySubmissionSaga({ payload }) {
  const { callbackActionSuccess, callbackActionFail } = payload;

  try {
    const { data } = payload;
    const { name, email } = data;

    const response = yield call(addCompany, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    const { companyProfileKey, profileHashedKey } = response.data.data;

    sessionStorage.setItem('companyNameAuthCookie', name);
    sessionStorage.setItem('companyEmailAuthCookie', email);
    sessionStorage.setItem('companyProfileKeyAuthCookie', companyProfileKey);
    sessionStorage.setItem('companyProfileHashedKeyAuthCookie', profileHashedKey);

    yield put(
      setSelectedCompanyProfile({
        email,
        token: companyProfileKey,
      }),
    );

    callbackActionSuccess();
    yield put(fetchAddOrEditCompanySubmissionSuccess(response.data));
  } catch (error) {
    callbackActionFail();
    yield put(fetchAddOrEditCompanySubmissionFail(error));
  }
}

function* companiesSaga() {
  yield takeLatest(
    companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION,
    fetchAddOrEditCompanySubmissionSaga,
  );
}

export default companiesSaga;
